import React from "react";
import { Box, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningIcon from "@mui/icons-material/Warning";
import styles from "./statCard.module.scss";

interface StatCardProps {
  type: "performer" | "fastest" | "attention";
  title: string;
  value: string;
  subtitle: string;
}

const StatCard: React.FC<StatCardProps> = ({
  type,
  title,
  value,
  subtitle,
}) => {
  const getCardStyle = () => {
    switch (type) {
      case "performer":
        return {
          background: "linear-gradient(180deg, #455391 0%, #6B7FD7 100%)",
          icon: <TrendingUpIcon className={styles.icon} />,
        };
      case "fastest":
        return {
          background: "linear-gradient(180deg, #08ADC2 0%, #00B290 100%)",
          icon: <AccessTimeIcon className={styles.icon} />,
        };

      case "attention":
        return {
          background: "linear-gradient(180deg, #FFA500 0%, #FF8C00 100%)",
          icon: <WarningIcon className={styles.icon} />,
        };

      default:
        return {
          background: "#5b6b9e",
          icon: <TrendingUpIcon className={styles.icon} />,
        };
    }
  };

  const cardStyle = getCardStyle();

  return (
    <Box className={styles.container} style={{ background: cardStyle.background }}>
      <Box className={styles.header}>
        {cardStyle.icon}
        <Typography className={styles.title}>{title}</Typography>
      </Box>
      <Typography className={styles.value}>{value}</Typography>
      <Typography className={styles.subtitle}>{subtitle}</Typography>
    </Box>
  );
};

export default StatCard;
